import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatEstadoService {
  constructor() {
    this.estados = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatEstado:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatEstado después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatEstado/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allEstados = response.data || [];
      this.estados = allEstados.filter(estado => estado.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Estados cargados:', this.estados.length, 'de', allEstados.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Estados cargados:', this.estados.length);
      
      return {
        success: true,
        data: this.estados,
        message: 'Estados cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar Estados:', error);
      this.error = error.message;
      this.estados = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(estadoData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...estadoData,
        EmpresaId: selectedEmpresa?.EmpresaId || estadoData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatEstado/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Estado guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar Estado:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar Estado'
      };
    }
  }

  async borrar(estadoData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...estadoData,
        EmpresaId: selectedEmpresa?.EmpresaId || estadoData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatEstado/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Estado eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar Estado:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar Estado'
      };
    }
  }

  async lectura(clave, paisClave) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatEstado/lectura'), {
        Clave: clave,
        PaisClave: paisClave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer Estado:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer Estado'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatEstado/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `estados_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar Estados:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar Estados'
      };
    }
  }
}

export default CatEstadoService;
